import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  formControl: {
    marginTop: theme.spacing(1),
    minWidth: 120,
  },
  root: {
    marginTop: theme.spacing(3),
    width: '100%',
    overflowX: 'auto',
    position: 'relative',
  },
  buttonGroup: {
    position: 'absolute',
    right: 0,
  },
  title: {
    margin: theme.spacing(2),
  },
  customSelect: {
    '& .MuiOutlinedInput-root': {
      height: '52px', // ปรับความสูงทั้งหมดของ Select
    },
    '& .MuiSelect-select': {
      padding: '11px 11px', // ปรับ padding ให้พอดีกับความสูง 48px
    },
  },
}));

export default useStyles;
